import styled from '@emotion/styled'

import { palette, typography } from '../constants'
import Text from './Text'

export type Color = 'black' | 'white' | 'tangerine' | 'fern' | 'rose'
type Kind = 'large' | 'small'

interface IProps {
  kind: Kind
  color?: Color
}

const fontSizes = {
  large: typography.fontSize.heading.large,
  small: typography.fontSize.heading.small,
}

const lineHeights = {
  large: '52px',
  small: '48px',
}

export default styled(Text.withComponent('h1'))<IProps>`
  color: ${({ color }) => (color ? palette[color] : palette.black)};
  font-size: ${({ kind }) => fontSizes[kind]};
  font-weight: ${typography.fontWeight.light};
  line-height: ${({ kind }) => lineHeights[kind]};
`
